var SDK_VERSION = '7.4.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
